import { useState, useEffect } from "react";
import Loader from "./Loader.jsx";

const Veliyeedugal = () => {
  const [veliyeedugal, setVeliyeedugal] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const openImage = (img) => {
    setSelectedImage(img);
  };

  const closeImage = () => {
    setSelectedImage(null);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("/data/veliyeedugal.json");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        console.log(data);

        setVeliyeedugal(data.veliyeedugal);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  if (loading) return <Loader />;
  if (error) return <div className="error-message">Error: {error}</div>;
  return (
    <div className="gallery-container">
      {/* <h1>Image Gallery</h1> */}
      <div className="image-grid1">
        {veliyeedugal.map((img, index) => (
          <div
            key={index}
            className="image-item"
            onClick={() => openImage(img)}
          >
            <img src={img} alt={`Gallery item ${index + 1}`} />
          </div>
        ))}
      </div>

      {selectedImage && (
        <div className="fullscreen-overlay" onClick={closeImage}>
          <div className="fullscreen-image-container">
            <img src={selectedImage} alt="Full screen" />
            <button className="close-button" onClick={closeImage}>
              ×
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Veliyeedugal;
